import { z } from "zod";

import { Question } from "./Question";

export const Answer = z
  .object({
    question: Question,
    answer: z.boolean().nullable(),
    elaboration: z.string().nullable(),
  })
  .passthrough();

export type Answer = z.infer<typeof Answer>;
